module.exports = __webpack_public_path__ + "img/gradeC.507b73fc.png";